export default __webpack_public_path__ + "static/media/NU-SC300BMPQ_Spec.82dcf54b.jpg";